import { render, staticRenderFns } from "./HeaderPages.vue?vue&type=template&id=5e6895fe"
import script from "./HeaderPages.vue?vue&type=script&lang=js"
export * from "./HeaderPages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports